import styled from "styled-components";

const BackgroundDiv = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  zindex: 999;
  background-color: rgba(0, 0, 0, 0.6);
`;

export default BackgroundDiv;
